const firebaseConfig = {
    apiKey: "AIzaSyBxm_NZ0ClNq-9xF53CQzuP4EowpWtXLM0",
    authDomain: "travel-guru-88318.firebaseapp.com",
    databaseURL: "https://travel-guru-88318.firebaseio.com",
    projectId: "travel-guru-88318",
    storageBucket: "travel-guru-88318.appspot.com",
    messagingSenderId: "622308540431",
    appId: "1:622308540431:web:27b76dd8963df06143637a"
  };
  export default firebaseConfig;